
import { Component, Vue } from 'vue-property-decorator';
import { fundListForAuthCommon, queryFinanceFundList } from '@/api/finance.js';
import editConfig from './editConfig.vue';
import { legalEntityMaternalMap, fundManageListColumns } from '@/utils/finance';

@Component({
  components: { editConfig }
})
class FundManageList extends Vue {
  searchParams = {
    financePeopleId: null,
    fundName: '',
    page: 1,
    pageSize: 20
  };
  financePeopleList: any[] = [];
  tableColumns = fundManageListColumns;
  dataList: object[] = [];
  total: number = 0;
  authProject: any = null;
  authConfigVisible = false;
  editFund = null;
  fundEditConfigVisible = false;

  async mounted() {
    this.fetchFinancePeople();
    this.fetchFundList();
  }

  async fetchFinancePeople() {
    fundListForAuthCommon().then(res => {
      this.financePeopleList = ((res.data && res.data.financePeopleList) || []).map(_ => ({ name: _.name, value: _.id }));
    });
  }

  async fetchFundList() {
    try {
      let res = await queryFinanceFundList(this.searchParams);
      let { data = [] } = res || {};
      this.dataList = data.list || [];
      this.total = data.total || 0;
    } catch (e) {}
  }

  selectChange(key) {
    return val => {
      this.searchParams[key] = val;
      this.fetchFundList();
    };
  }

  inputSearch(val) {
    this.searchParams.fundName = val;
    this.fetchFundList();
  }

  pageChange(e) {
    let { current } = e;
    this.searchParams.page = current;
    this.fetchFundList();
  }

  edit(fund) {
    this.editFund = fund;
    this.fundEditConfigVisible = true;
  }

  hideEditConfig() {
    this.fundEditConfigVisible = false;
  }

  render() {
    let {
      tableColumns,
      dataList,
      financePeopleList,
      selectChange,
      inputSearch,
      total,
      edit,
      pageChange,
      fetchFundList,
      editFund,
      fundEditConfigVisible,
      hideEditConfig
    } = this;
    let selectList = [
      {
        key: 'maternal',
        list: Object.keys(legalEntityMaternalMap).map(_ => ({ value: _, name: legalEntityMaternalMap[_] })),
        name: '是否为基金母体'
      },
      {
        key: 'financePeopleId',
        list: financePeopleList,
        name: '财务负责人'
      }
    ];
    return (
      <div>
        <a-breadcrumb>
          <a-breadcrumb-item>基金管理</a-breadcrumb-item>
          <a-breadcrumb-item>基金基本信息</a-breadcrumb-item>
        </a-breadcrumb>
        <a-row class="search-bar">
          {selectList.map(selectItem => (
            <a-col span="4">
              <a-select placeholder={selectItem.name} onChange={selectChange(selectItem.key)} class="select" allowClear>
                {selectItem.list.map(item => (
                  <a-select-option value={item.value}>{item.name}</a-select-option>
                ))}
              </a-select>
            </a-col>
          ))}
          <a-col span="16" class="search-container">
            <a-input-search placeholder="搜索基金简名称/简称" onSearch={inputSearch} class="input-search" />
          </a-col>
        </a-row>
        <div>
          <a-table
            columns={tableColumns}
            data-source={dataList}
            bordered
            scroll={{ x: true }}
            scopedSlots={{
              action: fund => (
                <div class="btns">
                  <a-button disabled={!fund.modifyFlag} data-ga-id="北冥-基金授权列表-点击权限" size="small" type="primary" onClick={edit.bind(this, fund)}>
                    编辑
                  </a-button>
                </div>
              )
            }}
            pagination={{
              total,
              current: this.searchParams.page,
              pageSize: this.searchParams.pageSize
            }}
            onChange={pageChange}
          />
        </div>

        {fundEditConfigVisible ? (
          <edit-config visible={this.fundEditConfigVisible} onHide={hideEditConfig} onRefresh={fetchFundList} fund={editFund} type="fund"></edit-config>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default FundManageList;
